const CorporateAgencyProjects = () => {
  return (
    <>
      <div className="sections pb-0">
        <div className="sections__head">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-8 col-lg-7 col-xxl-6">
                <h2 className="text-center mb-0 heading-text">
                  We don’t just make projects create experiences
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid container-fluid-fixed">
          <div className="row g-4">
            <div className="col-12">
              <div className="project-gallery">
                <div className="d-flex justify-content-center align-items-center gap-4 flex-wrap">
                  <a href="#" className="d-inline-block">
                    <img
                      src="assets/img/project-1.png"
                      alt="image"
                      className="img-fluid"
                    />
                  </a>
                  <a href="#" className="d-inline-block">
                    <img
                      src="assets/img/project-2.png"
                      alt="image"
                      className="img-fluid"
                    />
                  </a>
                  <a href="#" className="d-inline-block">
                    <img
                      src="assets/img/project-3.png"
                      alt="image"
                      className="img-fluid"
                    />
                  </a>
                  <a href="#" className="d-inline-block">
                    <img
                      src="assets/img/project-4.png"
                      alt="image"
                      className="img-fluid"
                    />
                  </a>
                  <a href="#" className="d-inline-block">
                    <img
                      src="assets/img/project-5.png"
                      alt="image"
                      className="img-fluid"
                    />
                  </a>
                  <a href="#" className="d-inline-block">
                    <img
                      src="assets/img/project-6.png"
                      alt="image"
                      className="img-fluid"
                    />
                  </a>
                  <a href="#" className="d-inline-block">
                    <img
                      src="assets/img/project-7.png"
                      alt="image"
                      className="img-fluid"
                    />
                  </a>
                  <a href="#" className="d-inline-block">
                    <img
                      src="assets/img/project-8.png"
                      alt="image"
                      className="img-fluid"
                    />
                  </a>
                  <a href="#" className="d-inline-block">
                    <img
                      src="assets/img/project-9.png"
                      alt="image"
                      className="img-fluid"
                    />
                  </a>
                </div>
                <button className="btn btn-primary project-gallery__btn">
                  All Templates
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CorporateAgencyProjects;
